import { Component, inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

// Removed: getCurrentLngData - migrated to ngx-translate
import { environment } from 'src/environments/environment';
import { FooterLogoComponent } from '../footer-logo/footer-logo.component';
import { MatTooltip } from '@angular/material/tooltip';
import { RouterLink } from '@angular/router';

import { BuyerService } from 'src/app/app-modules/buyer/_services/buyer/buyer.service';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { ToastService } from '../../services/toast/toast.service';
import { LocaleService } from '../../services/locale/locale.service';
import { StorageService } from 'src/app/Core/_services/storage/storage.service';
import { LocaleLinkPipe } from '../../_pipes/locale-link/locale-link.pipe';
@Component({
    selector: 'app-buyer-footer',
        standalone: true,
templateUrl: './buyer-new-footer.component.html',
    styleUrls: ['./buyer-new-footer.component.scss'],
    imports: [RouterLink, FormsModule, TranslatePipe, LocaleLinkPipe]
})
export class BuyerFooterComponent {
  websiteLink!: any;
  showKnowledgeBase: boolean = environment.showKnowledgeBase;
  private platformId = inject(PLATFORM_ID);

  constructor(
    private buyerService: BuyerService,
    private toastService: ToastService,
    public localeService: LocaleService,
    private storageService: StorageService
  ) {
    this.websiteLink = environment.wordpressUrl;
  }
  ngOnInit(): void {
  }
  subscriberEmail: string = '';

  onSubscribe() {
    this.toastService.clearAllActiveToasts();
    if (!this.subscriberEmail) return;

    this.buyerService.subscribeToNews(this.subscriberEmail).subscribe({
      next: (res) => {
        this.toastService.showSuccess(res?.data);
        this.subscriberEmail = '';
      },
      error: (err) => {
        this.toastService.showError(err?.error?.Error[0]);
        this.subscriberEmail = '';
      },
    });
  }

  openKnowledgeBase() {
    if (!isPlatformBrowser(this.platformId)) return;

    if (!this.storageService.userToken) {
      // If not logged in, open Knowledge Base directly (will redirect to login)
      window.open(environment.kbUrl, '_blank');
      return;
    }

    this.buyerService.generateKbToken().subscribe({
      next: (res: any) => {
        if (res?.data?.kb_url) {
          window.open(res.data.kb_url, '_blank');
        }
      },
      error: () => {
        // Fallback to direct Knowledge Base URL
        window.open(environment.kbUrl, '_blank');
      },
    });
  }
}
